import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { KeyCodeB } from '../../KeyShortcuts/KeyCodeB'
import { FeedbotSelect } from '../../design-system/selects'
import { actions } from '../../../store/botNames/botNamesSlice'
import { getFocusSelector } from '../../../store/botNames/selectors'
import { useBotSelectOptions } from './hooks'
import { switchBot } from '../../../lib/navigation'
import { openBotIdSelector } from '../../../store/app/selectors'
import { useBotConfiguration } from '../../../features/serverBots'

export const BotSelect: React.FC = () => {
  const dispatch = useDispatch()
  const focus = useSelector(getFocusSelector)
  const options = useBotSelectOptions()

  const selectedBotId = useSelector(openBotIdSelector)
  const selectedBotName = useBotConfiguration()?.name

  const inputRef: React.RefObject<HTMLDivElement> = useRef(null)

  useEffect(() => {
    if (focus && inputRef?.current) {
      inputRef?.current?.focus?.()
    }
  }, [focus, dispatch])

  const currentOption = selectedBotId
    ? { value: selectedBotId, label: selectedBotName || selectedBotId }
    : undefined

  return (
    <>
      <KeyCodeB />
      <SelectWrapper data-test="header-bot-select">
        <Select
          isClearable={false}
          inputRef={inputRef}
          value={currentOption}
          openMenuOnFocus={true}
          tabSelectsValue={true}
          isLoading={options === 'LOADING'}
          className="e2e-header-bot-selector"
          onBlur={() => dispatch(actions.setFocus(false))}
          onChange={option => option?.value && switchBot(option.value)}
          options={options === 'LOADING' ? [] : options}
          placeholder={
            options === 'LOADING'
              ? 'Loading bots ...'
              : options.length
              ? 'Click to select bot'
              : 'No bots available'
          }
        />
      </SelectWrapper>
    </>
  )
}

const SelectWrapper = styled.div`
  z-index: 42;
  height: 36px;
  min-width: 200px;
  position: relative;
  margin: 15px 24px 15px 24px;
`

const Select = styled(FeedbotSelect)`
  text-align: left;
  word-break: break-all;
`
